import { FC } from "react";

import { Box } from "@mui/material";

export const HueSliderPointer: FC = () => (
  <Box
    sx={(theme) => ({
      width: 20,
      height: 20,
      borderRadius: "50%",
      border: `3px solid ${theme.palette.common.white}`,
      boxShadow: 2,
      transform: "translate(-50%, -2px)",
    })}
  />
);
